/* eslint-disable no-console */
/**
 * Console log wrapper
 *
 * @class Ofcs.Logger
 */
const Logger = {
    enabled: true,
    console: false,
    lines: [],
    _handle(type, ...args) {
        if (!this.enabled) return;

        if (this.isConsoleAvailable()) console[type](...args);
        else this.lines.push({ type, ts: new Date(), message: this.toString(args) });
    },
    debug(...args) {
        this._handle('debug', ...args);
    },
    log(...args) {
        this._handle('log', ...args);
    },
    info(...args) {
        this._handle('info', ...args);
    },
    warn(...args) {
        this._handle('warn', ...args);
    },
    error(...args) {
        this._handle('error', ...args);
    },
    func(f, v) {
        this.log(f, '(', v, ')');
    },
    trace() {
        if (this.isConsoleAvailable()) console.trace();
    },

    /**
     * @return {boolean}
     */
    isConsoleAvailable() {
        return this.console && typeof console !== 'undefined';
    },

    /**
     * @param {Array} args
     * @return {string}
     */
    toString(args) {
        return args.filter(arg => typeof arg !== 'object').join(' ');
    },
    /**
     * @return {Array}
     */
    getLines() {
        return this.lines;
    },

    output(noFlush) {
        this.lines.forEach((line) => {
            const message = `${line.ts}: ${line.message} [${line.type}]`;
            switch (line.type) {
                case 'error':
                    console.error(message);
                    break;
                case 'warn':
                    console.warn(message);
                    break;
                case 'info':
                    console.info(message);
                    break;
                case 'debug':
                    console.debug(message);
                    break;
                default:
                    console.log(message);
                    break;
            }
        });

        if (!noFlush) this.lines = [];
    },
};

window.Logger = Logger;
export default Logger;
